// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取财达客户详情 GET /ra-customer/cd-info */
export async function raCustomerCdInfoUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultstring>('/ra-customer/cd-info', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 创建QMT策略客户 POST /ra-customer/create */
export async function raCustomerCreateUsingPOST(options?: { [key: string]: any }) {
  return request<API.BaseResultstring>('/ra-customer/create', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 添加量化客户资金账号 POST /ra-customer/fund-account/add */
export async function raCustomerFundAccountAddUsingPOST(
  body: API.RaCustomerFundAccountAddReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/ra-customer/fund-account/add', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取策略客户 GET /ra-customer/get */
export async function raCustomerGetUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultstring>('/ra-customer/get', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取量化客户详情 GET /ra-customer/info */
export async function raCustomerInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.raCustomerInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultRaCustomerInfoResp>('/ra-customer/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 我的交易授权详情 GET /ra-customer/trade-auth/my-info */
export async function raCustomerTradeAuthMyInfoUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultMyTradeAuthResp>('/ra-customer/trade-auth/my-info', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 我的交易授权记录列表 GET /ra-customer/trade-auth/my-record-list */
export async function raCustomerTradeAuthMyRecordListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.raCustomerTradeAuthMyRecordListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListMyTradeAuthRecordResp>(
    '/ra-customer/trade-auth/my-record-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 开通智投交易授权 POST /ra-customer/trade-auth/open */
export async function raCustomerTradeAuthOpenUsingPOST(options?: { [key: string]: any }) {
  return request<API.BaseResultstring>('/ra-customer/trade-auth/open', {
    method: 'POST',
    ...(options || {}),
  });
}
